/* ********************************************************************
BOLD HELPER FUNCTIONS
Contains helper tools for integrating Bold Apps with AJAX-based themes

Last modified: 2016-06-08 
******************************************************************** */

var Bold = Bold || {};
Bold.language = Bold.language || {};

Bold.cleanCart = function(cart){
  
  var cart_total = 0;
  cart.is_recurring = cart.is_recurring || false; 
  
  for(var item in cart.items){
    /* Check for RO discount. Requires V2 RO to get the discount percentage for Options */
    var discount_multiplier = 100.00;
    if (cart.items[item].properties && cart.items[item].properties._ro_discount_percentage){
      discount_multiplier -= parseFloat(cart.items[item].properties._ro_discount_percentage);
    }
    discount_multiplier *= 0.01;
    
    /* Check for a quantity multiplier. This could come from BTM or Builder */
    Bold.setRatio(cart.items[item]);
    
    /* Set the price to match the discounted price, if discount is set */
    if(cart.items[item].properties && cart.items[item].properties._ro_unformatted_price && !(cart.items[item].properties.master_builder || cart.items[item].properties._master_builder)){
      cart.items[item].price = Math.round(cart.items[item].price * discount_multiplier);
      cart.items[item].line_price = cart.items[item].price * cart.items[item].quantity;
    }
    
    if(cart.items[item].properties && ( (cart.items[item].properties._master_builder && cart.items[item].properties._builder_id) || (cart.items[item].properties.master_builder && cart.items[item].properties.builder_id) )){
      var builder_id = '';
      if(cart.items[item].properties._master_builder) builder_id = cart.items[item].properties._builder_id;
      else builder_id = cart.items[item].properties.builder_id;
      cart.items[item].builder_id = builder_id;
      cart.items[item].builder_type = 'bold-master';
      var bold_price = 0;
      for(var priceitem in cart.items){
        if(cart.items[priceitem].properties && (cart.items[priceitem].properties._builder_id == builder_id || cart.items[priceitem].properties.builder_id == builder_id )){
          
          /* Check for a quantity multiplier on the product , which could come from BTM or from Builder */
          Bold.setRatio(cart.items[priceitem]);

          bold_price += cart.items[priceitem].price * cart.items[priceitem].qty_ratio;
        }
      }
      
      /* Apply the RO discount (If unset, multiplies by 1.00) */
      cart.items[item].price = Math.round(bold_price * discount_multiplier);
      cart.items[item].line_price = cart.items[item].price * cart.items[item].quantity / cart.items[item].qty_ratio;
      
    }
  }
  /*Now that we've found all of the right prices, we can clear the prices on linked options and clean up the property fields*/
  for(var item in cart.items){
    /* Clean up linked priced options */
    if(cart.items[item].properties && ( cart.items[item].properties.builder_id && !cart.items[item].properties.master_builder || cart.items[item].properties._builder_id && !cart.items[item].properties._master_builder) ){
      if(cart.items[item].properties.builder_id) cart.items[item].builder_id = cart.items[item].properties.builder_id;
      else cart.items[item].builder_id = cart.items[item].properties._builder_id;
      
      cart.item_count -= cart.items[item].quantity;
      cart.items[item].builder_type = 'bold-hidden';
      cart.items[item].properties = { bold_hidden: true };
      cart.items[item].price = 0;
      cart.items[item].line_price = 0;
      continue;
    }
    
    /* Check for builder_info and set builder properties if found */
    if(cart.items[item].properties && (cart.items[item].properties.builder_info || cart.items[item].properties._builder_info) ){
      var builder_info;
      if(cart.items[item].properties.builder_info) builder_info = cart.items[item].properties.builder_info.split('~~');
      else builder_info = cart.items[item].properties._builder_info.split('~~');
      
      cart.items[item].builder_image_alt = builder_info[0];
      cart.items[item].builder_image_src = builder_info[1];
      cart.items[item].url = '/apps/productbuilder/'+builder_info[2];
    }
    
    /* Build the recurring order description, if the fields exist */
    if(cart.items[item].properties && cart.items[item].properties.frequency_num && cart.items[item].properties.frequency_type_text){
      cart.is_recurring = true;
      var recurring_desc = (Bold.language['recurring_desc_prefix'] || 'Delivered every ') + cart.items[item].properties.frequency_num + (Bold.language['recurring_desc_spacer'] || ' ') + cart.items[item].properties.frequency_type_text + (Bold.language['recurring_desc_suffix'] || '');
      var formatted_recurring_desc = '<div class = "bold_recurring_desc"><span class="bold_ro_every"  data-bold-lang="recurring_desc_prefix">' + (Bold.language['recurring_desc_prefix'] || 'Delivered every ') + '</\span><span class="bold_ro_frequency_num">' + cart.items[item].properties.frequency_num + '</\span>' + (Bold.language['recurring_desc_spacer'] ? '<span class="bold_ro_frequency_spacer" data-bold-lang="recurring_desc_spacer">' + Bold.language['recurring_desc_spacer'] + '</\span>' : ' ') + '<span class="bold_ro_frequency_type_text">' + cart.items[item].properties.frequency_type_text + '</span>' + (Bold.language['recurring_desc_suffix'] ? '<span class="bold_ro_frequency_suffix" data-bold-lang="recurring_desc_suffix">' + Bold.language['recurring_desc_suffix'] + '</\span>' : '') + '</div>';
      cart.items[item].bold_recurring_desc = recurring_desc;
      cart.items[item].bold_recurring_frequency_num = cart.items[item].properties.frequency_num;
      cart.items[item].bold_recurring_frequency_text = cart.items[item].properties.frequency_type_text;
      cart.items[item].formatted_recurring_desc = formatted_recurring_desc;
    }
    
    /* Set the BTM fields, if they exist */
    if(cart.items[item].qty_ratio && cart.items[item].quantity){
      cart.items[item].true_qty = cart.items[item].true_qty || cart.items[item].quantity;
      cart.items[item].quantity = cart.items[item].true_qty / cart.items[item].qty_ratio;
      
      cart.item_count = cart.item_count - cart.items[item].true_qty + cart.items[item].quantity;
    }
    
    /* Finally, remove any properties that shouldn't be showing to the customer */
    if(cart.items[item].properties) {
      cart.items[item].Bold = cart.items[item].Bold || {};
      for(var property in cart.items[item].properties){
        if( (property.slice(0,1) == '_' && property.slice(1,2) !='_' ) || property == 'master_builder' || property == 'builder_id' || property == 'builder_info' || property == 'frequency_type' || property == 'frequency_type_text' || property == 'frequency_num' || property == 'group_id' || property == 'discounted_price' || cart.items[item].properties[property] == ""){
          var clean_prop_name = property;
          if(clean_prop_name.slice(0,1) == '_') clean_prop_name = clean_prop_name.replace('_', '');
          
          /* Save the property to a Bold object on the item so that we can reference it if we need to, then delete the property. */
          cart.items[item].Bold[clean_prop_name] = cart.items[item].properties[property];
          delete cart.items[item].properties[property];
        }
      }
      cart.items[item].formatted_properties = Bold.propertiesDisplay(cart.items[item].properties);
    }

    /* Add the line price to our cart's total */
    if(!isNaN(cart.items[item].line_price))
      cart_total += cart.items[item].line_price;
  }
  window['mixed_cart'] = cart.is_recurring;
  cart.total_price = cart_total;
  return(cart);
};

Bold.setRatio = function(item){
    /* Check for a quantity multiplier. This could come from BTM or Builder */
    item.qty_ratio = item.qty_ratio || 1;
    if(item.properties && item.properties._btm_ratio){
      item.qty_ratio *= parseInt(item.properties._btm_ratio);
      item.is_btm = true;
    }
    if(item.properties && item.properties._bold_ratio){
      item.qty_ratio *= parseInt(item.properties._bold_ratio);
    }
    item.original_price = item.original_price || item.price;
    if(item.qty_ratio != 1){
      item.price = item.original_price * item.qty_ratio;  
    }
}

Bold.updateQtyBoxes = function(){
  /* First make sure all ratio information is properly set */
  jQuery.each(jQuery('[data-bold-ratio]'), function(index, obj){
    if(parseInt(jQuery(obj).data('bold-ratio')) != 1){
      /* The quantity displayed and the quantity passed to checkout are separate - create a hidden input with the true quantity */
      if(jQuery(obj).find('[name="updates[]"]').length && !jQuery(obj).find('.bold-true-quantity').length){
        jQuery(obj).find('[name="updates[]"]').addClass('bold-display-quantity').removeAttr('name').parent().append('<input type="hidden" name="updates[]" class="bold-true-quantity">');   
      }
    }
  });
  
  /* Now loop through all rows that have nonstandard quantity behaviour and set the correct quantity */
  jQuery.each(jQuery('[data-bold-ratio], .bold-master'), function(index, obj){
    var multiplier = parseInt(jQuery(obj).data('bold-ratio')) || 1;

    /* Find the base quantity value that we're basing the update on */
    var baseQty;
    if(jQuery(obj).find('.bold-display-quantity').length){
      baseQty = parseInt(jQuery(obj).find('.bold-display-quantity').val());
    }
    else{
      baseQty = parseInt(jQuery(obj).find('[name^=updates]').val());
    }
    if(isNaN(baseQty)) return; /* Abort this round if there's no base quantity to be found */
    
    /* Loop through all matching builder IDs to update. The name=updates will always hold the true quantity, a display-quantity (if it exists) will hold a 'faked' quantity based on the ratio */
    var components = jQuery(obj).closest('form').find('[data-bold-id=' + jQuery(obj).data('bold-id') + ']');
    if(components.length){
      jQuery.each(jQuery(components), function(cindex, component){
        var multiplier = parseInt(jQuery(component).data('bold-ratio')) || 1;

        if(jQuery(component).hasClass('bold-one-time-charge')){
          jQuery(component).find('[name*="updates"]').val(multiplier);
          jQuery(component).find('.bold-display-quantity').val(1);
        }else{
          jQuery(component).find('[name*="updates"]').val(multiplier * baseQty);
          jQuery(component).find('.bold-display-quantity').val(baseQty);
        }
      });
    }
    else{
      /* No builder ID, so we just have to worry about the multiplier ratio on this line */
      jQuery(obj).find('[name*="updates"]').val(multiplier * baseQty);
      jQuery(obj).find('.bold-display-quantity').val(baseQty);
    }
  });
};

Bold.removeBuilder = function(builder_id, success_callback, error_callback){
  if(typeof(builder_id) !== 'undefined')
    Bold.getCart(function(cart){ Bold.removeItemWithOptions(cart, builder_id, success_callback, error_callback) });
}

Bold.removeItemWithOptions = function(cart, builder_id, success_callback, error_callback){
  Bold.updateItemWithOptions(cart, builder_id, 0, success_callback, error_callback);
}

Bold.upateBuilder = function(builder_id, qty, success_callback, error_callback){
  if(typeof(builder_id) !== 'undefined')
    Bold.getCart(function(cart){ Bold.updateItemWithOptions(cart, builder_id, qty, success_callback, error_callback) });
}

Bold.updateItemWithOptions = function(cart, builder_id, qty, success_callback, error_callback){
  
  var datastr = '';
  for(var i in cart.items){
    /* Inspect each cell for any undefined and skip. */
    if(typeof(cart.items[i].quantity)==='undefined') continue;
    if(datastr.length > 1) datastr += '&';
    if(builder_id && cart.items[i].properties && (cart.items[i].properties.builder_id == builder_id || cart.items[i].properties._builder_id == builder_id || cart.items[i].builder_id == builder_id) ){
      var line_qty = qty;
      if(cart.items[i].qty_ratio) line_qty *= cart.items[i].qty_ratio;
      
      if(line_qty > 1000000) {
        console.error('Update aborted: Updating quantities would put the product quantity over Shopify\'s 1,000,000 quantity limit.');
        if(typeof(error_callback)==='function') error_callback();
        return false;
      }
      datastr += 'updates[]=' + line_qty;
    }
    else
      if (cart.items[i].true_qty)
        datastr += 'updates[]=' + cart.items[i].true_qty;
      else
        datastr += 'updates[]=' + cart.items[i].quantity;
  }

  var params = { 
    data: datastr, 
    dataType: 'json', 
    url:'/cart/update.js', 
    method:"POST", 
    success: function(data) {
      if(typeof(success_callback)==='function')
        success_callback(data);
      else if(typeof(Shopify.onCartUpdate)==='function')
        Shopify.onCartUpdate(data)
        },
    error: function(t, e) {
      if(typeof(error_callback)==='function')
        error_callback(t, e);
      else if(typeof(Shopify.onError)==='function')
        Shopify.onError(t, e);
    }
  };
  jQuery.ajax(params);
  
}

Bold.changeItem = function(line, qty, success_callback, error_callback){
  var index = line - 1; //Shopify uses 1-based indexing
  //Get the cart to see if the given line item hasa builder ID. If it does, use our code. Otherwise, just update the line normally.
  Bold.getCart(function(cart){
    if(cart.items[index].builder_id)
      Bold.updateItemWithOptions(cart, cart.items[index].builder_id, qty, success_callback, error_callback);
    
    else{
      //Make sure that BTM products are correctly updated 
      if(cart.items[index].qty_ratio) qty *= cart.items[index].qty_ratio;
      
      var params = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + qty + "&line=" + line,
        dataType: "json",
        success: function(data) {
          if(typeof(success_callback)==='function')
            success_callback(data);
          else if(typeof(Shopify.onCartUpdate)==='function')
            Shopify.onCartUpdate(data)
        },
        error: function(t, e) {
          if(typeof(error_callback)==='function')
            error_callback(t, e);
          else if(typeof(Shopify.onError)==='function')
            Shopify.onError(t, e);
        }
      };
      jQuery.ajax(params);
    }
  });
  
}

Bold.propertiesDisplay = function(properties){
  if(typeof(properties) !== "object")
    return "";
  
  var property_desc = '<div class="bold-properties">';
  for(var key in properties){
    property_desc += '<div class="bold_option_line"><span class="bold_option_title">' + key + '</\span><span class="bold_option_seperator">: </\span><span class="bold_option_value">';
    if(typeof(properties[key]) === 'string' && properties[key].indexOf('/uploads/') > -1)
      property_desc += '<a href="' + properties[key] + '" data-bold-lang="uploaded_file">' + (Bold.language['uploaded_file'] || 'Uploaded file') + '</a></\span></div>';
    else
      property_desc += properties[key] + '</\span></div>';

  }
  property_desc += '</div>';
  return property_desc;
};

/* Shopify doesn't let us set objects as cart attributes - this pair of functions lets us stringify data and retrieve it later */
Bold.setCartAttrObject = function(name, attributes, success_callback, error_callback){
  var data = { attributes: {} };
  data.attributes[name] = encodeURI(JSON.stringify(attributes));
  var params = {
    url: '/cart/update.js',
    type: 'post',
    dataType: 'json',
    data: data,
    success: success_callback || function(c){ console.info(c) },
    error: error_callback || function(a, b){ console.error(a, b)}
  };
  jQuery.ajax(params);
}

Bold.getCartAttrObj = function(name, cart){
  if(typeof(cart)!=='object'){
    Bold.getCart(function(c) { Bold.getCartAttrObj(name, c) });
    return;
  }
  try {
    return Bold['data_' + name] = JSON.parse(decodeURI(cart.attributes[name]));
  } catch (e) {
    return Bold['data_' + name] = false;
  }
};

//     Bold: Helper for using Quantity Breaks with Quick-Shop
//    Run on JS function that opens Quickshop. Add data-product-id="" somewhere on the form
Bold.update_message_quickshop = function(productID){
jQuery("#shappify-qty-msg-" + productID).html(jQuery('[data-product-id="' + productID +'"] #variant_html_' + jQuery('[data-product-id="' + productID +'"] [name="id"]').val()).html());

if(jQuery('[data-product-id="' + productID +'"] [name="id"]:checked').length){
  jQuery("#shappify-qty-msg-" + productID).html(jQuery('#variant_html_' + jQuery("[name='id']:checked").val()).html());
}
  var prds=jQuery(".shapp_qb_prod");
  var i=0;
  for(i=0;i<prds.length;i++){
    var shapp_var_id=jQuery(prds[i]).find("[name='id']").val();
    var shapp_message=jQuery("#variant_html_"+ shapp_var_id).html();
    var shapp_message_container=jQuery(prds[i]).find(".shappify-qty-msg");
    shapp_message_container.html(shapp_message);
  }
}

// Bold: Helper functions for updating BTM quantities and updating old BTM installs with new BTM property fields
Bold.upgradeBTMFields = function(form){
  var $form = jQuery(form);
  $form.find('.btm_upgrade').remove();  //Remove the BTM upgrade fields (if they exist) before adding new ones
  $form.find('.btm_quantity_input[name="properties[quantity]"]').attr('name', 'properties[_btm_quantity]')
  
  if($form.find('.bold-btm .measurement_div').length){
    var btm_qty = 1;
    
    if($form.find('.btm_quantity_input').length)
      btm_qty = parseInt($form.find('.btm_quantity_input').attr('name', "properties[_btm_quantity]").val());
    else
      $form.prepend('<input type="hidden" class="btm_upgrade btm_qty" name="properties[_btm_quantity]" value=' + btm_qty + '>');

    var true_qty = parseInt($form.find('[name="quantity"]').last().val());
    var btm_ratio = true_qty / btm_qty;
    
    var option_qty_input = '<input type="hidden" class="btm_upgrade btm_options" name="quantity" value=' + btm_qty + '>';
    var btm_ratio_input = '<input type="hidden" class="btm_upgrade btm_ratio" name="properties[_btm_ratio]" value=' + btm_ratio + '>'
    $form.prepend(option_qty_input).prepend(btm_ratio_input);
  }
  
}


/*  Shopify API functions that we need but are not guaranteed to pre-exist on the site   */
Bold.getCart = function(t) {
    jQuery.getJSON("/cart.js", function(e, n) {
        "function" == typeof t ? t(Bold.cleanCart(e)) : Shopify.onCartUpdate(Bold.cleanCart(e));
    });
};

Bold.addItemFromForm = function(form, success_callback, error_callback){		
  var data, contentType, processData;		

  var dataSelector;		
  /* Some like to pass the ID, some like to pass the actual form. Check what's coming so we can be all-purpose and agnostic */		
  if(typeof(form)==='string')		
    dataSelector = '#' + form;		
  else		
    dataSelector = '#' + $(form).attr('id');		
  if(typeof(FormData)==='function'){		
    /* Using FormData we can replace the AJAX submit with a submit that sends uploaded files */		
    data = new FormData(document.querySelector(dataSelector));		
    contentType = false;		
    processData = false;		
  }		
  else{		
    /* Failsafe conditions for older browsers */		
    if(jQuery(dataSelector).find('input[type="file"]').length){		
      //File inputs exist - do a proper form submit and skip the fancy ajax-ing		
      jQuery(dataSelector).submit();		
      return false;		
    }		

    data = jQuery(dataSelector).serialize();		
    contentType = 'application/x-www-form-urlencoded; charset=UTF-8';		
    processData = 'true';		
  }		
  /* Another IE failsafe - IE 10/11 only have partial FormData support */
  if(typeof(data.getAll)==='undefined'){
    if(jQuery(dataSelector).find('input[type="file"]').length){		
      //File inputs exist - do a proper form submit and skip the fancy ajax-ing		
      jQuery(dataSelector).submit();		
      return false;		
    }	
    data = jQuery(dataSelector).serialize();		
    contentType = 'application/x-www-form-urlencoded; charset=UTF-8';		
    processData = 'true';	
  }
  var params = {		
    url: '/cart/add',		
    data: data,		
    processData: processData,		
    contentType: contentType,		
    type: 'POST',		
    dataType: 'json',		

    success: function(result){		
      if(typeof(success_callback)==='function')		
        success_callback(result);		
      else if (typeof(Shopify.onItemAdded)==='function')		
        Shopify.onItemAdded(result)		
        },		

    error: function(a, b){		
      if(typeof(error_callback)==='function')		
        success_callback(a, b);		
      else if (typeof(Shopify.onError)==='function')		
        Shopify.onError(a, b)		
        }		
  };		
  $.ajax(params);		
};

Bold.updateCartFromForm = function(t, e) {
    var n = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(Bold.cleanCart(t)) : Shopify.onCartUpdate(Bold.cleanCart(t))
        },
        error: function(t, e) {
            Shopify.onError(t, e)
        }
    };
    jQuery.ajax(n)
}

Bold.updateProperties = function(line, qty, properties, success_callback, error_callback, options){

  var params = {
    url: '/cart/change.js',
    data: {
      line: line,
      quantity: qty,
      properties: properties
    },
    type: 'post',
    dataType: 'json',
    success: function(data){
      if(typeof(success_callback)==='function') success_callback(Bold.cleanCart(data));
    },
    error: function(a, b){
      if(typeof(error_callback)==='function') error_callback(a, b);
    }
  }
  
  if(typeof options == 'object' && options.sequential) {
    params.async = false;
  }
  jQuery.ajax(params);
}

jQuery(document).ready(function(){ jQuery('.bold-remove-on-load').remove(); });

/* ********************************************************************
BOLD HELPER FUNCTIONS
Contains helper tools for integrating Bold Apps with AJAX-based themes

Last modified: 2016-06-08 
******************************************************************** */

var Bold = Bold || {};
Bold.language = Bold.language || {};

Bold.cleanCart = function(cart){
  
  var cart_total = 0;
  cart.is_recurring = cart.is_recurring || false; 
  
  for(var item in cart.items){
    /* Check for RO discount. Requires V2 RO to get the discount percentage for Options */
    var discount_multiplier = 100.00;
    if (cart.items[item].properties && cart.items[item].properties._ro_discount_percentage){
      discount_multiplier -= parseFloat(cart.items[item].properties._ro_discount_percentage);
    }
    discount_multiplier *= 0.01;
    
    /* Check for a quantity multiplier. This could come from BTM or Builder */
    Bold.setRatio(cart.items[item]);
    
    /* Set the price to match the discounted price, if discount is set */
    if(cart.items[item].properties && cart.items[item].properties._ro_unformatted_price && !(cart.items[item].properties.master_builder || cart.items[item].properties._master_builder)){
      cart.items[item].price = Math.round(cart.items[item].price * discount_multiplier);
      cart.items[item].line_price = cart.items[item].price * cart.items[item].quantity;
    }
    
    if(cart.items[item].properties && ( (cart.items[item].properties._master_builder && cart.items[item].properties._builder_id) || (cart.items[item].properties.master_builder && cart.items[item].properties.builder_id) )){
      var builder_id = '';
      if(cart.items[item].properties._master_builder) builder_id = cart.items[item].properties._builder_id;
      else builder_id = cart.items[item].properties.builder_id;
      cart.items[item].builder_id = builder_id;
      cart.items[item].builder_type = 'bold-master';
      var bold_price = 0;
      for(var priceitem in cart.items){
        if(cart.items[priceitem].properties && (cart.items[priceitem].properties._builder_id == builder_id || cart.items[priceitem].properties.builder_id == builder_id )){
          
          /* Check for a quantity multiplier on the product , which could come from BTM or from Builder */
          Bold.setRatio(cart.items[priceitem]);

          bold_price += cart.items[priceitem].price * cart.items[priceitem].qty_ratio;
        }
      }
      
      /* Apply the RO discount (If unset, multiplies by 1.00) */
      cart.items[item].price = Math.round(bold_price * discount_multiplier);
      cart.items[item].line_price = cart.items[item].price * cart.items[item].quantity / cart.items[item].qty_ratio;
      
    }
  }
  /*Now that we've found all of the right prices, we can clear the prices on linked options and clean up the property fields*/
  for(var item in cart.items){
    /* Clean up linked priced options */
    if(cart.items[item].properties && ( cart.items[item].properties.builder_id && !cart.items[item].properties.master_builder || cart.items[item].properties._builder_id && !cart.items[item].properties._master_builder) ){
      if(cart.items[item].properties.builder_id) cart.items[item].builder_id = cart.items[item].properties.builder_id;
      else cart.items[item].builder_id = cart.items[item].properties._builder_id;
      
      cart.item_count -= cart.items[item].quantity;
      cart.items[item].builder_type = 'bold-hidden';
      cart.items[item].properties = { bold_hidden: true };
      cart.items[item].price = 0;
      cart.items[item].line_price = 0;
      continue;
    }
    
    /* Check for builder_info and set builder properties if found */
    if(cart.items[item].properties && (cart.items[item].properties.builder_info || cart.items[item].properties._builder_info) ){
      var builder_info;
      if(cart.items[item].properties.builder_info) builder_info = cart.items[item].properties.builder_info.split('~~');
      else builder_info = cart.items[item].properties._builder_info.split('~~');
      
      cart.items[item].builder_image_alt = builder_info[0];
      cart.items[item].builder_image_src = builder_info[1];
      cart.items[item].url = '/apps/productbuilder/'+builder_info[2];
    }
    
    /* Build the recurring order description, if the fields exist */
    if(cart.items[item].properties && cart.items[item].properties.frequency_num && cart.items[item].properties.frequency_type_text){
      cart.is_recurring = true;
      var recurring_desc = (Bold.language['recurring_desc_prefix'] || 'Delivered every ') + cart.items[item].properties.frequency_num + (Bold.language['recurring_desc_spacer'] || ' ') + cart.items[item].properties.frequency_type_text + (Bold.language['recurring_desc_suffix'] || '');
      var formatted_recurring_desc = '<div class = "bold_recurring_desc"><span class="bold_ro_every"  data-bold-lang="recurring_desc_prefix">' + (Bold.language['recurring_desc_prefix'] || 'Delivered every ') + '</\span><span class="bold_ro_frequency_num">' + cart.items[item].properties.frequency_num + '</\span>' + (Bold.language['recurring_desc_spacer'] ? '<span class="bold_ro_frequency_spacer" data-bold-lang="recurring_desc_spacer">' + Bold.language['recurring_desc_spacer'] + '</\span>' : ' ') + '<span class="bold_ro_frequency_type_text">' + cart.items[item].properties.frequency_type_text + '</span>' + (Bold.language['recurring_desc_suffix'] ? '<span class="bold_ro_frequency_suffix" data-bold-lang="recurring_desc_suffix">' + Bold.language['recurring_desc_suffix'] + '</\span>' : '') + '</div>';
      cart.items[item].bold_recurring_desc = recurring_desc;
      cart.items[item].bold_recurring_frequency_num = cart.items[item].properties.frequency_num;
      cart.items[item].bold_recurring_frequency_text = cart.items[item].properties.frequency_type_text;
      cart.items[item].formatted_recurring_desc = formatted_recurring_desc;
    }
    
    /* Set the BTM fields, if they exist */
    if(cart.items[item].qty_ratio && cart.items[item].quantity){
      cart.items[item].true_qty = cart.items[item].true_qty || cart.items[item].quantity;
      cart.items[item].quantity = cart.items[item].true_qty / cart.items[item].qty_ratio;
      
      cart.item_count = cart.item_count - cart.items[item].true_qty + cart.items[item].quantity;
    }
    
    /* Finally, remove any properties that shouldn't be showing to the customer */
    if(cart.items[item].properties) {
      cart.items[item].Bold = cart.items[item].Bold || {};
      for(var property in cart.items[item].properties){
        if( (property.slice(0,1) == '_' && property.slice(1,2) !='_' ) || property == 'master_builder' || property == 'builder_id' || property == 'builder_info' || property == 'frequency_type' || property == 'frequency_type_text' || property == 'frequency_num' || property == 'group_id' || property == 'discounted_price' || cart.items[item].properties[property] == ""){
          var clean_prop_name = property;
          if(clean_prop_name.slice(0,1) == '_') clean_prop_name = clean_prop_name.replace('_', '');
          
          /* Save the property to a Bold object on the item so that we can reference it if we need to, then delete the property. */
          cart.items[item].Bold[clean_prop_name] = cart.items[item].properties[property];
          delete cart.items[item].properties[property];
        }
      }
      cart.items[item].formatted_properties = Bold.propertiesDisplay(cart.items[item].properties);
    }

    /* Add the line price to our cart's total */
    if(!isNaN(cart.items[item].line_price))
      cart_total += cart.items[item].line_price;
  }
  window['mixed_cart'] = cart.is_recurring;
  cart.total_price = cart_total;
  return(cart);
};

Bold.setRatio = function(item){
    /* Check for a quantity multiplier. This could come from BTM or Builder */
    item.qty_ratio = item.qty_ratio || 1;
    if(item.properties && item.properties._btm_ratio){
      item.qty_ratio *= parseInt(item.properties._btm_ratio);
      item.is_btm = true;
    }
    if(item.properties && item.properties._bold_ratio){
      item.qty_ratio *= parseInt(item.properties._bold_ratio);
    }
    item.original_price = item.original_price || item.price;
    if(item.qty_ratio != 1){
      item.price = item.original_price * item.qty_ratio;  
    }
}

Bold.updateQtyBoxes = function(){
  /* First make sure all ratio information is properly set */
  jQuery.each(jQuery('[data-bold-ratio]'), function(index, obj){
    if(parseInt(jQuery(obj).data('bold-ratio')) != 1){
      /* The quantity displayed and the quantity passed to checkout are separate - create a hidden input with the true quantity */
      if(jQuery(obj).find('[name="updates[]"]').length && !jQuery(obj).find('.bold-true-quantity').length){
        jQuery(obj).find('[name="updates[]"]').addClass('bold-display-quantity').removeAttr('name').parent().append('<input type="hidden" name="updates[]" class="bold-true-quantity">');   
      }
    }
  });
  
  /* Now loop through all rows that have nonstandard quantity behaviour and set the correct quantity */
  jQuery.each(jQuery('[data-bold-ratio], .bold-master'), function(index, obj){
    var multiplier = parseInt(jQuery(obj).data('bold-ratio')) || 1;

    /* Find the base quantity value that we're basing the update on */
    var baseQty;
    if(jQuery(obj).find('.bold-display-quantity').length){
      baseQty = parseInt(jQuery(obj).find('.bold-display-quantity').val());
    }
    else{
      baseQty = parseInt(jQuery(obj).find('[name^=updates]').val());
    }
    if(isNaN(baseQty)) return; /* Abort this round if there's no base quantity to be found */
    
    /* Loop through all matching builder IDs to update. The name=updates will always hold the true quantity, a display-quantity (if it exists) will hold a 'faked' quantity based on the ratio */
    var components = jQuery(obj).closest('form').find('[data-bold-id=' + jQuery(obj).data('bold-id') + ']');
    if(components.length){
      jQuery.each(jQuery(components), function(cindex, component){
        var multiplier = parseInt(jQuery(component).data('bold-ratio')) || 1;

        if(jQuery(component).hasClass('bold-one-time-charge')){
          jQuery(component).find('[name*="updates"]').val(multiplier);
          jQuery(component).find('.bold-display-quantity').val(1);
        }else{
          jQuery(component).find('[name*="updates"]').val(multiplier * baseQty);
          jQuery(component).find('.bold-display-quantity').val(baseQty);
        }
      });
    }
    else{
      /* No builder ID, so we just have to worry about the multiplier ratio on this line */
      jQuery(obj).find('[name*="updates"]').val(multiplier * baseQty);
      jQuery(obj).find('.bold-display-quantity').val(baseQty);
    }
  });
};

Bold.removeBuilder = function(builder_id, success_callback, error_callback){
  if(typeof(builder_id) !== 'undefined')
    Bold.getCart(function(cart){ Bold.removeItemWithOptions(cart, builder_id, success_callback, error_callback) });
}

Bold.removeItemWithOptions = function(cart, builder_id, success_callback, error_callback){
  Bold.updateItemWithOptions(cart, builder_id, 0, success_callback, error_callback);
}

Bold.upateBuilder = function(builder_id, qty, success_callback, error_callback){
  if(typeof(builder_id) !== 'undefined')
    Bold.getCart(function(cart){ Bold.updateItemWithOptions(cart, builder_id, qty, success_callback, error_callback) });
}

Bold.updateItemWithOptions = function(cart, builder_id, qty, success_callback, error_callback){
  
  var datastr = '';
  for(var i in cart.items){
    /* Inspect each cell for any undefined and skip. */
    if(typeof(cart.items[i].quantity)==='undefined') continue;
    if(datastr.length > 1) datastr += '&';
    if(builder_id && cart.items[i].properties && (cart.items[i].properties.builder_id == builder_id || cart.items[i].properties._builder_id == builder_id || cart.items[i].builder_id == builder_id) ){
      var line_qty = qty;
      if(cart.items[i].qty_ratio) line_qty *= cart.items[i].qty_ratio;
      
      if(line_qty > 1000000) {
        console.error('Update aborted: Updating quantities would put the product quantity over Shopify\'s 1,000,000 quantity limit.');
        if(typeof(error_callback)==='function') error_callback();
        return false;
      }
      datastr += 'updates[]=' + line_qty;
    }
    else
      if (cart.items[i].true_qty)
        datastr += 'updates[]=' + cart.items[i].true_qty;
      else
        datastr += 'updates[]=' + cart.items[i].quantity;
  }

  var params = { 
    data: datastr, 
    dataType: 'json', 
    url:'/cart/update.js', 
    method:"POST", 
    success: function(data) {
      if(typeof(success_callback)==='function')
        success_callback(data);
      else if(typeof(Shopify.onCartUpdate)==='function')
        Shopify.onCartUpdate(data)
        },
    error: function(t, e) {
      if(typeof(error_callback)==='function')
        error_callback(t, e);
      else if(typeof(Shopify.onError)==='function')
        Shopify.onError(t, e);
    }
  };
  jQuery.ajax(params);
  
}

Bold.changeItem = function(line, qty, success_callback, error_callback){
  var index = line - 1; //Shopify uses 1-based indexing
  //Get the cart to see if the given line item hasa builder ID. If it does, use our code. Otherwise, just update the line normally.
  Bold.getCart(function(cart){
    if(cart.items[index].builder_id)
      Bold.updateItemWithOptions(cart, cart.items[index].builder_id, qty, success_callback, error_callback);
    
    else{
      //Make sure that BTM products are correctly updated 
      if(cart.items[index].qty_ratio) qty *= cart.items[index].qty_ratio;
      
      var params = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + qty + "&line=" + line,
        dataType: "json",
        success: function(data) {
          if(typeof(success_callback)==='function')
            success_callback(data);
          else if(typeof(Shopify.onCartUpdate)==='function')
            Shopify.onCartUpdate(data)
        },
        error: function(t, e) {
          if(typeof(error_callback)==='function')
            error_callback(t, e);
          else if(typeof(Shopify.onError)==='function')
            Shopify.onError(t, e);
        }
      };
      jQuery.ajax(params);
    }
  });
  
}

Bold.propertiesDisplay = function(properties){
  if(typeof(properties) !== "object")
    return "";
  
  var property_desc = '<div class="bold-properties">';
  for(var key in properties){
    property_desc += '<div class="bold_option_line"><span class="bold_option_title">' + key + '</\span><span class="bold_option_seperator">: </\span><span class="bold_option_value">';
    if(typeof(properties[key]) === 'string' && properties[key].indexOf('/uploads/') > -1)
      property_desc += '<a href="' + properties[key] + '" data-bold-lang="uploaded_file">' + (Bold.language['uploaded_file'] || 'Uploaded file') + '</a></\span></div>';
    else
      property_desc += properties[key] + '</\span></div>';

  }
  property_desc += '</div>';
  return property_desc;
};

/* Shopify doesn't let us set objects as cart attributes - this pair of functions lets us stringify data and retrieve it later */
Bold.setCartAttrObject = function(name, attributes, success_callback, error_callback){
  var data = { attributes: {} };
  data.attributes[name] = encodeURI(JSON.stringify(attributes));
  var params = {
    url: '/cart/update.js',
    type: 'post',
    dataType: 'json',
    data: data,
    success: success_callback || function(c){ console.info(c) },
    error: error_callback || function(a, b){ console.error(a, b)}
  };
  jQuery.ajax(params);
}

Bold.getCartAttrObj = function(name, cart){
  if(typeof(cart)!=='object'){
    Bold.getCart(function(c) { Bold.getCartAttrObj(name, c) });
    return;
  }
  try {
    return Bold['data_' + name] = JSON.parse(decodeURI(cart.attributes[name]));
  } catch (e) {
    return Bold['data_' + name] = false;
  }
};

//     Bold: Helper for using Quantity Breaks with Quick-Shop
//    Run on JS function that opens Quickshop. Add data-product-id="" somewhere on the form
Bold.update_message_quickshop = function(productID){
jQuery("#shappify-qty-msg-" + productID).html(jQuery('[data-product-id="' + productID +'"] #variant_html_' + jQuery('[data-product-id="' + productID +'"] [name="id"]').val()).html());

if(jQuery('[data-product-id="' + productID +'"] [name="id"]:checked').length){
  jQuery("#shappify-qty-msg-" + productID).html(jQuery('#variant_html_' + jQuery("[name='id']:checked").val()).html());
}
  var prds=jQuery(".shapp_qb_prod");
  var i=0;
  for(i=0;i<prds.length;i++){
    var shapp_var_id=jQuery(prds[i]).find("[name='id']").val();
    var shapp_message=jQuery("#variant_html_"+ shapp_var_id).html();
    var shapp_message_container=jQuery(prds[i]).find(".shappify-qty-msg");
    shapp_message_container.html(shapp_message);
  }
}

// Bold: Helper functions for updating BTM quantities and updating old BTM installs with new BTM property fields
Bold.upgradeBTMFields = function(form){
  var $form = jQuery(form);
  $form.find('.btm_upgrade').remove();  //Remove the BTM upgrade fields (if they exist) before adding new ones
  $form.find('.btm_quantity_input[name="properties[quantity]"]').attr('name', 'properties[_btm_quantity]')
  
  if($form.find('.bold-btm .measurement_div').length){
    var btm_qty = 1;
    
    if($form.find('.btm_quantity_input').length)
      btm_qty = parseInt($form.find('.btm_quantity_input').attr('name', "properties[_btm_quantity]").val());
    else
      $form.prepend('<input type="hidden" class="btm_upgrade btm_qty" name="properties[_btm_quantity]" value=' + btm_qty + '>');

    var true_qty = parseInt($form.find('[name="quantity"]').last().val());
    var btm_ratio = true_qty / btm_qty;
    
    var option_qty_input = '<input type="hidden" class="btm_upgrade btm_options" name="quantity" value=' + btm_qty + '>';
    var btm_ratio_input = '<input type="hidden" class="btm_upgrade btm_ratio" name="properties[_btm_ratio]" value=' + btm_ratio + '>'
    $form.prepend(option_qty_input).prepend(btm_ratio_input);
  }
  
}


/*  Shopify API functions that we need but are not guaranteed to pre-exist on the site   */
Bold.getCart = function(t) {
    jQuery.getJSON("/cart.js", function(e, n) {
        "function" == typeof t ? t(Bold.cleanCart(e)) : Shopify.onCartUpdate(Bold.cleanCart(e));
    });
};

Bold.addItemFromForm = function(form, success_callback, error_callback){		
  var data, contentType, processData;		

  var dataSelector;		
  /* Some like to pass the ID, some like to pass the actual form. Check what's coming so we can be all-purpose and agnostic */		
  if(typeof(form)==='string')		
    dataSelector = '#' + form;		
  else		
    dataSelector = '#' + $(form).attr('id');		
  if(typeof(FormData)==='function'){		
    /* Using FormData we can replace the AJAX submit with a submit that sends uploaded files */		
    data = new FormData(document.querySelector(dataSelector));		
    contentType = false;		
    processData = false;		
  }		
  else{		
    /* Failsafe conditions for older browsers */		
    if(jQuery(dataSelector).find('input[type="file"]').length){		
      //File inputs exist - do a proper form submit and skip the fancy ajax-ing		
      jQuery(dataSelector).submit();		
      return false;		
    }		

    data = jQuery(dataSelector).serialize();		
    contentType = 'application/x-www-form-urlencoded; charset=UTF-8';		
    processData = 'true';		
  }		
  /* Another IE failsafe - IE 10/11 only have partial FormData support */
  if(typeof(data.getAll)==='undefined'){
    if(jQuery(dataSelector).find('input[type="file"]').length){		
      //File inputs exist - do a proper form submit and skip the fancy ajax-ing		
      jQuery(dataSelector).submit();		
      return false;		
    }	
    data = jQuery(dataSelector).serialize();		
    contentType = 'application/x-www-form-urlencoded; charset=UTF-8';		
    processData = 'true';	
  }
  var params = {		
    url: '/cart/add',		
    data: data,		
    processData: processData,		
    contentType: contentType,		
    type: 'POST',		
    dataType: 'json',		

    success: function(result){		
      if(typeof(success_callback)==='function')		
        success_callback(result);		
      else if (typeof(Shopify.onItemAdded)==='function')		
        Shopify.onItemAdded(result)		
        },		

    error: function(a, b){		
      if(typeof(error_callback)==='function')		
        success_callback(a, b);		
      else if (typeof(Shopify.onError)==='function')		
        Shopify.onError(a, b)		
        }		
  };		
  $.ajax(params);		
};

Bold.updateCartFromForm = function(t, e) {
    var n = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(Bold.cleanCart(t)) : Shopify.onCartUpdate(Bold.cleanCart(t))
        },
        error: function(t, e) {
            Shopify.onError(t, e)
        }
    };
    jQuery.ajax(n)
}

Bold.updateProperties = function(line, qty, properties, success_callback, error_callback, options){

  var params = {
    url: '/cart/change.js',
    data: {
      line: line,
      quantity: qty,
      properties: properties
    },
    type: 'post',
    dataType: 'json',
    success: function(data){
      if(typeof(success_callback)==='function') success_callback(Bold.cleanCart(data));
    },
    error: function(a, b){
      if(typeof(error_callback)==='function') error_callback(a, b);
    }
  }
  
  if(typeof options == 'object' && options.sequential) {
    params.async = false;
  }
  jQuery.ajax(params);
}

jQuery(document).ready(function(){ jQuery('.bold-remove-on-load').remove(); });

